import { CircularProgress, Paper, Theme, makeStyles } from "@material-ui/core"
import { useTranslation } from "react-i18next"

import ChatWindow from "../../chat/components/ChatWindow"
import ErrorList from "../../components/ErrorList"
import { useGetChatByEntityQuery } from "../../chat/api"
import { APP_MAX_WIDTH } from "../../constants"

type Props = {
  projectId: string
}

const ProjectChat = ({ projectId }: Props) => {
  const classes = useStyles()
  const translations = useTranslations()

  const {
    data: chat,
    isLoading,
    isError,
  } = useGetChatByEntityQuery({ type: "project", entityId: projectId }, { refetchOnMountOrArgChange: true })

  if (isLoading) return <CircularProgress />
  if (isError || !chat) return <ErrorList errors={[translations.fetchErrorChat]} />

  return (
    <div className={classes.container}>
      <Paper variant="outlined" className={classes.window}>
        <ChatWindow chats={[chat]} chatId={chat.id} embedded />
      </Paper>
    </div>
  )
}

const defaultTranslations = {
  fetchErrorChat: "Failed to load chat",
}

const useTranslations = (): typeof defaultTranslations => {
  const { t } = useTranslation("chat")

  return {
    fetchErrorChat: t("failedToLoadChat", defaultTranslations.fetchErrorChat),
  }
}

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    justifyContent: "center",
  },

  window: {
    width: "100%",
    maxWidth: APP_MAX_WIDTH,
    height: "calc(100vh - 128px)",

    display: "flex",
    flexDirection: "column",

    overflow: "hidden",
    borderRadius: theme.spacing(0.5),
  },
}))

export default ProjectChat
